import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const { Equals, NotEquals } = OdataComparator;

const fetchPendingReleasesCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_PENDING_RELEASES_COUNT_SUCCESS',
    payload
  } as const);

export const fetchPendingReleasesCount = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const params = new QueryBuilder()
      .top(0)
      .filter(f => f.filterBy('status', Equals, 'Pending').filterBy('requestedById', NotEquals, organizationId))
      .toQueryParam();

    const { data } = await axios.get<{ '@odata.count': number }>(
      `/api/v3.01/organizations(${organizationId})/releases`,
      {
        params
      }
    );

    dispatch(fetchPendingReleasesCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchPendingReleasesCountSuccess>;
